import { FunctionComponent, useLayoutEffect, useRef } from 'react';

const Sentinel: FunctionComponent<{ onLoad(): Promise<void> }> = ({ onLoad }) => {
	const ref = useRef<HTMLSpanElement | null>(null);

	useLayoutEffect(() => {
		if (ref.current === null) {
			return undefined;
		}

		const observer = new IntersectionObserver(async (entries) => {
			if (entries.find((entry) => entry.isIntersecting) !== undefined) {
				await onLoad();
			}
		}, {});

		observer.observe(ref.current);
		return () => {
			observer.disconnect();
		};
	}, [onLoad]);

	return <span ref={ref} style={{ position: 'absolute', left: 0, bottom: 0, width: 0, height: 300, zIndex: 1000 }} />;
};

export const InfiniteScroll: FunctionComponent<{ onLoad(): Promise<void> }> = ({ children, onLoad }) => (
	<div style={{ position: 'relative' }}>
		{children}
		<Sentinel onLoad={onLoad} />
	</div>
);
